class LocalStorage {
  static setAuthenthicationToken(access_token) {
    localStorage.setItem("access_token", access_token);
  }
  static getAuthenticationToken() {
    return localStorage.getItem("access_token");
  }
  static setRefreshToken(refresh_token) {
    localStorage.setItem("refresh_token", refresh_token);
  }
  static setSSOFlag(flag) {
    localStorage.setItem("sso_auth", flag);
  }
  static removeRefreshToken() {
    localStorage.removeItem("refresh_token");
  }
  static removeAuthenticationToken() {
    localStorage.removeItem("access_token");
  }
  static removeSSOFlag() {
    localStorage.removeItem("sso_auth");
  }
  static getRefreshToken() {
    return localStorage.getItem("refresh_token");
  }
  static setAppLanguage(app_language) {
    localStorage.setItem("emotii_language", app_language);
  }
  static getAppLanguage() {
    return localStorage.getItem("emotii_language");
  }
  static setInterfaceLanguage(interface_language) {
    localStorage.setItem("interface_language", interface_language);
  }
  static getInterfaceLanguage() {
    return localStorage.getItem("interface_language");
  }
  static setConferenceCallLanguage(language) {
    if (language) localStorage.setItem("conference_call_language", language);
  }
  static getConferenceCallLanguage() {
    return localStorage.getItem("conference_call_language");
  }
  static setWsLink(websocket_link) {
    localStorage.setItem("websocket_link", websocket_link);
  }
  static getWsLink() {
    return localStorage.getItem("websocket_link");
  }
  static setQcWsLink(websocket_link) {
    localStorage.setItem("qc_websocket_link", websocket_link);
  }
  static getQcWsLink() {
    return localStorage.getItem("qc_websocket_link");
  }
  static setRatingCounter(counter) {
    localStorage.setItem("rating_counter", counter);
  }
  static getRatingCounter() {
    return localStorage.getItem("rating_counter");
  }
  static getSSOFlag() {
    return localStorage.getItem("sso_auth");
  }
  static getFirstMessageRead() {
    return localStorage.getItem("first_use_message_read");
  }
  static getTryProCard() {
    return localStorage.getItem("try_pro_subscription_card");
  }
  static setFirstMessageRead(first_message_read) {
    return localStorage.setItem("first_use_message_read", first_message_read);
  }
  static setTryProCard(date) {
    return localStorage.setItem("try_pro_subscription_card", date);
  }
  static getFirstWelcomeMessage() {
    return localStorage.getItem("first_welcome_message_read");
  }
  static setFirstWelcomeMessageRead(first_message_read) {
    return localStorage.setItem(
      "first_welcome_message_read",
      first_message_read
    );
  }
  static setInvitedBy(invited_by) {
    return localStorage.setItem("invited_by", invited_by);
  }
  static getInvitedBy() {
    return localStorage.getItem("invited_by");
  }
  static removeInvitedBy() {
    localStorage.removeItem("invited_by");
  }
  static setCallVirtualBg(bg) {
    return localStorage.setItem("call_virtual_bg", bg);
  }
  static getCallVirtualBg(bg) {
    return localStorage.getItem("call_virtual_bg");
  }

  static setOutputDevice(deviceId) {
    return localStorage.setItem("output_device_id", deviceId);
  }
  static getOutputDevice() {
    return localStorage.getItem("output_device_id");
  }
  static setInputDevice(deviceId) {
    return localStorage.setItem("input_device_id", deviceId);
  }
  static getInputDevice() {
    return localStorage.getItem("input_device_id");
  }
  static setVideoInputDevice(deviceId) {
    return localStorage.setItem("video_input_device_id", deviceId);
  }
  static getVideoInputDevice() {
    return localStorage.getItem("video_input_device_id");
  }

  static setAppTheme(theme) {
    return localStorage.setItem("emotii_theme", theme);
  }
  static getAppTheme() {
    return localStorage.getItem("emotii_theme");
  }
  static setAutomaticTranslate(automaticTranslate) {
    return localStorage.setItem("automatic_translate", automaticTranslate);
  }
  static getAutomaticTranslate() {
    return localStorage.getItem("automatic_translate");
  }

  static setSidebar(option) {
    return localStorage.setItem("sidebar", option);
  }
  static getSidebar() {
    return localStorage.getItem("sidebar");
  }
  static setEmotiiVoice(option) {
    return localStorage.setItem("emotii_voice", option);
  }
  static getEmotiiVoice() {
    return localStorage.getItem("emotii_voice");
  }

  static setConferenceMediaPermissions(preferences) {
    try {
      localStorage.setItem(
        "conference_media_permissions",
        JSON.stringify(preferences || {})
      );
    } catch {
      // noop
    }
  }

  static getConferenceMediaPermissions() {
    const raw = localStorage.getItem("conference_media_permissions");
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (err) {
      return null;
    }
  }

  static removeConferenceMediaPermissions() {
    localStorage.removeItem("conference_media_permissions");
  }

  static setCallScopedVolume(key, callUuid, volume) {
    try {
      localStorage.setItem(key, JSON.stringify({ callUuid, volume }));
    } catch {
      // noop
    }
  }

  static getCallScopedVolume(key, callUuid) {
    const raw = localStorage.getItem(key);
    if (!raw || !callUuid) return null;
    try {
      const parsed = JSON.parse(raw);
      if (parsed?.callUuid !== callUuid) return null;
      const volume = parseInt(parsed.volume, 10);
      return Number.isNaN(volume) ? null : volume;
    } catch {
      return null;
    }
  }

  static setIncomingVoiceVolume(callUuid, volume) {
    return LocalStorage.setCallScopedVolume("emotii_incoming_voice_volume", callUuid, volume);
  }

  static getIncomingVoiceVolume(callUuid) {
    return LocalStorage.getCallScopedVolume("emotii_incoming_voice_volume", callUuid);
  }

  static setEmotiiVoiceVolume(callUuid, volume) {
    return LocalStorage.setCallScopedVolume("emotii_voice_volume", callUuid, volume);
  }

  static getEmotiiVoiceVolume(callUuid) {
    return LocalStorage.getCallScopedVolume("emotii_voice_volume", callUuid);
  }

  static setConferenceTtsPlaybackSpeed(speed) {
    const parsed = Number(speed);
    const normalized =
      parsed === 1 || parsed === 1.25 || parsed === 1.5 ? parsed : 1.0;
    return localStorage.setItem(
      "conference_tts_playback_speed",
      String(normalized)
    );
  }

  static getConferenceTtsPlaybackSpeed() {
    const raw = localStorage.getItem("conference_tts_playback_speed");
    const parsed = Number(raw);
    if (parsed === 1 || parsed === 1.25 || parsed === 1.5) {
      return parsed;
    }
    return 1.0;
  }

  static setDimVoiceEnabled(enabled) {
    return localStorage.setItem("emotii_dim_voice_enabled", enabled);
  }

  static getDimVoiceEnabled() {
    const value = localStorage.getItem("emotii_dim_voice_enabled");
    return value === "true";
  }

  static setRemoteNoiseFilterEnabled(enabled) {
    return localStorage.setItem("emotii_remote_noise_filter_enabled", enabled);
  }

  static getRemoteNoiseFilterEnabled() {
    const value = localStorage.getItem("emotii_remote_noise_filter_enabled");
    if (value === null) return true;
    return value === "true";
  }

  static getToolHintCounter(hintKey) {
    return localStorage.getItem(`hint_${hintKey}`);
  }

  static setToolHintCounter(hintKey, value) {
    localStorage.setItem(`hint_${hintKey}`, value);
  }

  static setBridgeOptedOut(value) {
    localStorage.setItem("bridge_opted_out", value);
  }

  static getBridgeOptedOut() {
    return localStorage.getItem("bridge_opted_out") === "true";
  }

  static removeBridgeOptedOut() {
    localStorage.removeItem("bridge_opted_out");
  }

  static setVoiceCloneId(voiceId) {
    localStorage.setItem("voice_clone_id", voiceId);
  }

  static getVoiceCloneId() {
    return localStorage.getItem("voice_clone_id");
  }

  static removeVoiceCloneId() {
    localStorage.removeItem("voice_clone_id");
  }

  static setAuthMethod(method) {
    localStorage.setItem("auth_method", method);
  }

  static getAuthMethod() {
    return localStorage.getItem("auth_method");
  }

  static removeAuthMethod() {
    localStorage.removeItem("auth_method");
  }

}

export default LocalStorage;
